import { DocumentsApi } from '@agilelab/plugin-wb-documents-common';
import { createApiRef } from '@mainstage/core-plugin-api';

export const documentsApiRef = createApiRef<DocumentsApi>({
  id: 'wb-documents',
});
